<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <div v-if="isGameCompleted()" class="next-btn-wrapper">
      {{ LG("PP_GameComplete1") }} <strong>{{ getSituationName() }}</strong
      >{{ LG("PP_GameComplete2") }} {{ LG("G_continueLabel") }} {{ LG("PP_GameComplete3") }}
      <b-button class="funky-shape next-btn" v-on:click="onFinishedButtonClicked()">{{ LG("G_continueLabel") }}</b-button>
    </div>

    <div :class="getPlayFrame()">
      <div class="root-image">
        <OverlayObjects :overlays="getOverlays()" :circles="overlaysCircles" :bg="getOverlayBG()" bgwidth="801" bgheight="534" alt="Une classe préscolaire avec des livres et des jouets" @object-clicked="onObjectClicked" @search-clicked="onSearchClicked()"></OverlayObjects>
      </div>
    </div>
    <div v-for="(overlay, index) in getOverlays()" :key="overlay.id">
      <div v-show="showingPopup == index">
        <!-- <PopupOverlay :popupImage="getPopupImage(overlay)" choices="yes" imageWidth="300" :altPopupImage="LG(getPopupAlt(overlay))" :okButtonLabel="LG(getAddToNotesLabel())" @ok-clicked="onOkButtonClicked()" @no-clicked="onNoButtonClicked(overlay)" @close-clicked="onCloseButtonClicked()"> -->
        <PopupOverlay :id="overlay.id" :popupImage="getPopupImage(overlay)" choices="yes" imageWidth="300" :altPopupImage="LG(getPopupAlt(overlay))" :okButtonLabel="LG(getAddToNotesLabel())" @ok-clicked="onOkButtonClicked(overlay)" @no-clicked="onNoButtonClicked(overlay)" @close-clicked="onCloseButtonClicked()">
          <div class="popup-area">
            <br aria-hidden="true" />
            <br aria-hidden="true" />
            <br aria-hidden="true" />

            <p v-html="LG(getClueText(overlay))" v-if="!hasCluePopover(overlay)"></p>
            <p v-if="hasCluePopover(overlay)">
              <PopupLinker :paragraph="LG(getClueText(overlay))" :content="LG(getCluePopover(overlay))"></PopupLinker>
            </p>
            <!-- <p v-show="!isClueRelevant(overlay) && !newVersion()" v-html="LG('PP_irrelevantText')"></p> -->
            <br aria-hidden="true" />
            <br aria-hidden="true" />
          </div>
        </PopupOverlay>
        <div v-if="hasClueAudio(overlay)">
          <AudioPlayer id="id-clue-audio" :ref="getClueAudioRef(index)" autoplay="no" @audio-ended="onClueAudioEnded()" :url="getClueAudio(overlay)"></AudioPlayer>
        </div>
        <div v-if="hasRecapAudio(overlay)">
          <AudioPlayer id="id-recap-audio" :ref="getRecapAudioRef(index)" autoplay="no" :url="getRecapAudio(overlay)"></AudioPlayer>
        </div>
        <div v-if="hasNoteAudio(overlay)">
          <AudioPlayer id="id-note-audio" :ref="getNoteAudioRef(index)" autoplay="no" :url="getNoteAudio(overlay)"></AudioPlayer>
        </div>
      </div>

      <AudioPlayer id="sfxGoodAnswer-id" ref="sfxGoodAnswerRef" autoplay="no" :url="sfxGoodAnswer" registered="no"></AudioPlayer>
      <AudioPlayer id="id-clue-audio-pertinent" ref="clueAudioPertinentRef" autoplay="no" :url="clueAudioPertinent"></AudioPlayer>
      <AudioPlayer id="id-clue-audio-notpertinent" ref="clueAudioNotPertinentRef" autoplay="no" :url="clueAudioNotPertinent"></AudioPlayer>
      <AudioPlayer id="id-clue-audio-notpertinent" ref="keepClueRef" autoplay="no" :url="keepClueAudio"></AudioPlayer>
      <AudioPlayer id="id-clue-music-audio" ref="musicAudioRef" volume="0.4" loop="yes" autoplay="no" :url="musicAudio"></AudioPlayer>

      <PopupOverlay :id="overlay.id + '_wrong'" :popupImage="getPopupImage(overlay)" imageWidth="300" :altPopupImage="LG(getPopupAlt(overlay))" :okButtonLabel="LG(getAddToNotesLabel())" @ok-clicked="onDismissWrongAnswerMessage()" @close-clicked="onCloseButtonClicked()">
        <br aria-hidden="true" />
        <p v-html="LG('PP_irrelevantText')" v-if="!isClueRelevant(overlay)"></p>
        <p v-html="LG('PP_relevantText')" v-if="isClueRelevant(overlay)"></p>
      </PopupOverlay>
    </div>
    <!-- <div v-show="showingRecap"> -->
    <ClueRecaps :situationIndex="getSituationIndexFromSituationName(situationName)" :recaps="getRecaps()" ref="refClues" @close-clicked="onRecapComplete(false)" @ok-clicked="onRecapComplete(true)" @next-clicked="onNextButtonClicked()" @prev-clicked="onPrevButtonClicked()" @tab-clicked="onTabClicked"></ClueRecaps>
    <!-- </div> -->
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import OverlayObjects from "../components/OverlayObjects.vue";
import PopupOverlay from "../components/PopupOverlayNew.vue";
import ClueRecaps from "../components/ClueRecaps.vue";
import PopupLinker from "../components/PopupLinker.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

export default {
  components: {
    ProgressBars,
    OverlayObjects,
    PopupOverlay,
    ClueRecaps,
    PopupLinker,
    AudioPlayer,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      // Images

      // Variables
      currentCircle: 0,
      currentClue: 0,
      overlaysCircles: [
        {
          id: "id-circle1",
          x: 100,
          y: 500,
          width: 100,
          image: "icons/empty.png",
          alt: "",
          selectable: "no",
          loaded: false,
        },
        {
          id: "id-circle2",
          x: 225,
          y: 500,
          width: 100,
          image: "icons/empty.png",
          alt: "",
          selectable: "no",
          loaded: false,
        },
        {
          id: "id-circle3",
          x: 350,
          y: 500,
          width: 100,
          image: "icons/empty.png",
          alt: "",
          selectable: "no",
          loaded: false,
        },
        {
          id: "id-circle4",
          x: 475,
          y: 500,
          width: 100,
          image: "icons/empty.png",
          alt: "",
          selectable: "no",
          loaded: false,
        },
        {
          id: "id-circle5",
          x: 600,
          y: 500,
          width: 100,
          image: "icons/empty.png",
          alt: "",
          selectable: "no",
          loaded: false,
        },
        {
          id: "id-circle-search",
          x: 725,
          y: 500,
          width: 100,
          image: "icons/search.png",
          alt: "",
          selectable: "yes",
          loaded: false,
          rollover: "icons/rollover_search.png",
        },
      ],
      situations: [
        {
          id: "id-situation-1",
          bg: "scenes/scene1/MES_Background.png",
          overlays: [
            {
              id: "id-calendar",
              x: 158,
              y: 136,
              width: 83,
              preview: "scenes/scene1/MES1_Indice1.png",
              image: "scenes/scene1/MES1_Indice1_cutout.png",
              //rollover: "scenes/scene1/MES1_Indice1_rollover.png",
              isMouseOver: false,
              alt: "PP_S1_altObject1",
              clueText: "PP_S1_clueObject1",
              audioUrl: "/audio/scene1/L'accueil des familles_007.mp3",
              audioRecapUrl: "/audio/scene1/L'accueil des familles_008.mp3",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_009.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-rug",
              x: 497,
              y: 361,
              width: 203,
              preview: "scenes/scene1/MES1_Indice2.png",
              image: "scenes/scene1/MES1_Indice2_cutout.png",
              //rollover: "scenes/scene1/MES1_Indice2_cutout.gif",
              isMouseOver: false,
              alt: "PP_S1_altObject2",
              clueText: "PP_S1_clueObject2",
              audioUrl: "/audio/scene1/L'accueil des familles_010.mp3",
              audioRecapUrl: "/audio/scene1/L'accueil des familles_011.mp3",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_012.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-shelf",
              x: 366,
              y: 184,
              width: 115,
              preview: "scenes/scene1/MES1_Indice3.png",
              image: "scenes/scene1/MES1_Indice3_cutout.png",
              //rollover: "scenes/scene1/MES1_Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S1_altObject3",
              clueText: "PP_S1_clueObject3",
              audioUrl: "/audio/scene1/L'accueil des familles_013.mp3",
              audioRecapUrl: "/audio/scene1/L'accueil des familles_014.mp3",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_015.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-clock",
              x: 267,
              y: 126,
              width: 51,
              preview: "scenes/scene1/MES1_Indice4.png",
              image: "scenes/scene1/MES1_Indice4_cutout.png",
              //rollover: "scenes/scene1/MES1_Indice4_rollover.png",
              isMouseOver: false,
              alt: "PP_S1_altObject4",
              clueText: "PP_S1_clueObject4",
              audioUrl: "/audio/scene1/L'accueil des familles_022.mp3",
              relevant: false,
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-mirror",
              x: 154,
              y: 275,
              width: 126,
              preview: "scenes/scene1/MES1_Indice5.png",
              image: "scenes/scene1/MES1_Indice5_cutout.png",
              //rollover: "scenes/scene1/MES1_Indice5_rollover.png",
              isMouseOver: false,
              alt: "PP_S1_altObject5",
              clueText: "PP_S1_clueObject5",
              audioUrl: "/audio/scene1/L'accueil des familles_016.mp3",
              audioRecapUrl: "/audio/scene1/L'accueil des familles_017.mp3",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_018.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-basket",
              x: 255,
              y: 234,
              width: 59,
              preview: "scenes/scene1/MES1_Indice6.png",
              image: "scenes/scene1/MES1_Indice6_cutout.png",
              //rollover: "scenes/scene1/MES1_Indice6_rollover.png",
              isMouseOver: false,
              alt: "PP_S1_altObject5",
              clueText: "PP_S1_clueObject6",
              audioUrl: "/audio/scene1/L'accueil des familles_019.mp3",
              audioRecapUrl: "/audio/scene1/L'accueil des familles_020.mp3",
              audioNoteUrl: "/audio/scene1/L'accueil des familles_021.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-calendar",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene1/MES1_Indice1_Sommaire.png",
              recapAlt: "PP_S1_O1_altRecap",
              recapText: "PP_S1_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S1_O1_recapText_bullet1",
                },
                {
                  text: "PP_S1_O1_recapText_bullet2",
                },
                {
                  text: "PP_S1_O1_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S1_O1_recapPedagogy",
            },
            {
              id: "id-rug",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene1/MES1_Indice2_Sommaire.png",
              recapAlt: "PP_S1_O2_altRecap",
              recapText: "PP_S1_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S1_O2_recapText_bullet1",
                },
                {
                  text: "PP_S1_O2_recapText_bullet2",
                },
                {
                  text: "PP_S1_O2_recapText_bullet3",
                },
                {
                  text: "PP_S1_O2_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S1_O2_recapPedagogy",
            },
            {
              id: "id-shelf",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene1/MES1_Indice3_Sommaire.png",
              recapAlt: "PP_S1_O3_altRecap",
              recapText: "PP_S1_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S1_O3_recapText_bullet1",
                },
                {
                  text: "PP_S1_O3_recapText_bullet2",
                },
                {
                  text: "PP_S1_O3_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S1_O3_recapPedagogy",
            },
            {
              id: "id-mirror",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene1/MES1_Indice5_Sommaire.png",
              recapAlt: "PP_S1_O4_altRecap",
              recapText: "PP_S1_O4_recapText",
              recapBullets: [
                {
                  text: "PP_S1_O4_recapText_bullet1",
                },
                {
                  text: "PP_S1_O4_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S1_O4_recapPedagogy",
              popover: "PP_S1_O4_popover",
            },
            {
              id: "id-basket",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene1/MES1_Indice6_Sommaire.png",
              recapAlt: "PP_S1_O5_altRecap",
              recapText: "PP_S1_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S1_O5_recapText_bullet1",
                },
                {
                  text: "PP_S1_O5_recapText_bullet2",
                },
                {
                  text: "PP_S1_O5_recapText_bullet3",
                },
                {
                  text: "PP_S1_O5_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S1_O5_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-2",
          bg: "scenes/scene2/MES_Background.png",
          overlays: [
            {
              id: "id-boy-drawing",
              x: 183,
              y: 382,
              width: 240,
              preview: "scenes/scene2/MES2Indice1.png",
              image: "scenes/scene2/MES2Indice1_cutout.png",
              isMouseOver: true,
              alt: "PP_S2_altObject1",
              clueText: "PP_S2_clueObject1",
              audioUrl: "/audio/scene2/L'écoute visible_003.mp3",
              audioRecapUrl: "/audio/scene2/L'écoute visible_004.mp3",
              audioNoteUrl: "/audio/scene2/L'écoute visible_005.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-camera",
              x: 379,
              y: 144,
              width: 23,
              preview: "scenes/scene2/MES2Indice2.png",
              image: "scenes/scene2/MES2Indice2_cutout.png",
              isMouseOver: true,
              alt: "PP_S2_altObject2",
              clueText: "PP_S2_clueObject2",
              audioUrl: "/audio/scene2/L'écoute visible_006.mp3",
              audioRecapUrl: "/audio/scene2/L'écoute visible_007.mp3",
              audioNoteUrl: "/audio/scene2/L'écoute visible_008.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-gate",
              x: 26,
              y: 179,
              width: 135,
              preview: "scenes/scene2/MES2Indice3.png",
              image: "scenes/scene2/MES2Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S2_altObject3",
              clueText: "PP_S2_clueObject3",
              relevant: false,
              audioUrl: "/audio/scene2/L'écoute visible_018.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-chariot",
              x: 437,
              y: 236,
              width: 68,
              preview: "scenes/scene2/MES2Indice4.png",
              image: "scenes/scene2/MES2Indice4_cutout.png",
              isMouseOver: false,
              alt: "PP_S2_altObject4",
              clueText: "PP_S2_clueObject4",
              audioUrl: "/audio/scene2/L'écoute visible_009.mp3",
              audioRecapUrl: "/audio/scene2/L'écoute visible_010.mp3",
              audioNoteUrl: "/audio/scene2/L'écoute visible_011.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-children",
              x: 20,
              y: 291,
              width: 133,
              preview: "scenes/scene2/MES2Indice5.png",
              image: "scenes/scene2/MES2Indice5_cutout.png",
              isMouseOver: true,
              alt: "PP_S2_altObject5",
              clueText: "PP_S2_clueObject5",
              audioUrl: "/audio/scene2/L'écoute visible_012.mp3",
              audioRecapUrl: "/audio/scene2/L'écoute visible_013.mp3",
              audioNoteUrl: "/audio/scene2/L'écoute visible_014.mp3",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-nest",
              x: 709,
              y: 190,
              width: 49,
              preview: "scenes/scene2/MES2Indice6.png",
              image: "scenes/scene2/MES2Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S2_altObject6",
              clueText: "PP_S2_clueObject6",
              audioUrl: "/audio/scene2/L'écoute visible_015.mp3",
              audioRecapUrl: "/audio/scene2/L'écoute visible_016.mp3",
              audioNoteUrl: "/audio/scene2/L'écoute visible_017.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-boy-drawing",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene2/MES2Indice1.png",
              recapAlt: "PP_S2_O1_altRecap",
              recapText: "PP_S2_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S2_O1_recapText_bullet1",
                },
              ],
              recap2Text: "PP_S2_O1_recap2Text",
              recap2Bullets: [
                {
                  text: "PP_S2_O1_recap2Text_bullet1",
                },
                {
                  text: "PP_S2_O1_recap2Text_bullet2",
                },
              ],
              recapPedagogy: "PP_S2_O1_recapPedagogy",
              popover: "PP_S2_O1_recapPedagogy_popover",
            },
            {
              id: "id-camera",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene2/MES2Indice2.png",
              recapAlt: "PP_S2_O2_altRecap",
              recapText: "PP_S2_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S2_O2_recapText_bullet1",
                },
                {
                  text: "PP_S2_O2_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S2_O2_recapPedagogy",
            },
            {
              id: "id-chariot",
              clueId: 4,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene2/MES2Indice4.png",
              recapAlt: "PP_S2_O4_altRecap",
              recapText: "PP_S2_O4_recapText",
              recapBullets: [
                {
                  text: "PP_S2_O4_recapText_bullet1",
                },
                {
                  text: "PP_S2_O4_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S2_O4_recapPedagogy",
            },
            {
              id: "id-children",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene2/MES2Indice5.png",
              recapAlt: "PP_S2_O5_altRecap",
              recapText: "PP_S2_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S2_O5_recapText_bullet1",
                },
                {
                  text: "PP_S2_O5_recapText_bullet2",
                },
                {
                  text: "PP_S2_O5_recapText_bullet3",
                },
                {
                  text: "PP_S2_O5_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S2_O5_recapPedagogy",
            },
            {
              id: "id-nest",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene2/MES2Indice6.png",
              recapAlt: "PP_S2_O6_altRecap",
              recapText: "PP_S2_O6_recapText",
              recapBullets: [
                {
                  text: "PP_S2_O6_recapText_bullet1",
                },
                {
                  text: "PP_S2_O6_recapText_bullet2",
                },
                {
                  text: "PP_S2_O6_recapText_bullet3",
                },
                {
                  text: "PP_S2_O6_recapText_bullet4",
                },
                {
                  text: "PP_S2_O6_recapText_bullet5",
                },
              ],
              recapPedagogy: "PP_S2_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-3",
          bg: "scenes/scene3/MES_Background.png",
          overlays: [
            {
              id: "id-leonie",
              x: 242,
              y: 196,
              width: 196,
              preview: "scenes/scene3/MES3Indice1.png",
              image: "scenes/scene3/MES3Indice1_cutout.png",
              isMouseOver: true,
              alt: "PP_S3_altObject1",
              clueText: "PP_S3_clueObject1",
              popover: "PP_S3_clueObject1_popover",
              audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_03.mp3",
              audioRecapUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_04.mp3",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_05.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-kenji",
              x: 191,
              y: 280,
              width: 56,
              preview: "scenes/scene3/MES3Indice2.png",
              image: "scenes/scene3/MES3Indice2_cutout.png",
              isMouseOver: false,
              alt: "PP_S3_altObject2",
              clueText: "PP_S3_clueObject2",
              popover: "PP_S3_clueObject2_popover",
              audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_06.mp3",
              audioRecapUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_07.mp3",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_08.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-zahra",
              x: 363,
              y: 285,
              width: 293,
              preview: "scenes/scene3/MES3Indice5.png",
              image: "scenes/scene3/MES3Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S3_altObject5",
              clueText: "PP_S3_clueObject5",
              audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_12.mp3",
              audioRecapUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_13.mp3",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_14.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-caroline",
              x: 401,
              y: 209,
              width: 105,
              preview: "scenes/scene3/MES3Indice3.png",
              image: "scenes/scene3/MES3Indice3_cutout.png",
              isMouseOver: true,
              alt: "PP_S3_altObject3",
              clueText: "PP_S3_clueObject3",
              audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_09.mp3",
              audioRecapUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_10.mp3",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_11.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-chips",
              x: 698,
              y: 398,
              width: 80,
              preview: "scenes/scene3/MES3Indice4.png",
              image: "scenes/scene3/MES3Indice4_cutout.png",
              isMouseOver: true,
              alt: "PP_S3_altObject4",
              clueText: "PP_S3_clueObject4",
              relevant: false,
              audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_18.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-sophie",
              x: 349,
              y: 147,
              width: 54,
              preview: "scenes/scene3/MES3Indice6.png",
              image: "scenes/scene3/MES3Indice6_cutout.png",
              isMouseOver: true,
              alt: "PP_S3_altObject6",
              clueText: "PP_S3_clueObject6",
              audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_15.mp3",
              audioRecapUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_16.mp3",
              audioNoteUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_17.mp3",
              loaded: true,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-leonie",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene3/MES3Indice1.png",
              recapAlt: "PP_S3_O1_altRecap",
              recapText: "PP_S3_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S3_O1_recapText_bullet1",
                },
                {
                  text: "PP_S3_O1_recapText_bullet2",
                },
                {
                  text: "PP_S3_O1_recapText_bullet3",
                  popover: "PP_S3_O1_recapText_bullet3_popover",
                },
              ],
              recapPedagogy: "PP_S3_O1_recapPedagogy",
            },
            {
              id: "id-kenji",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene3/MES3Indice2.png",
              recapAlt: "PP_S3_O2_altRecap",
              recapText: "PP_S3_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S3_O2_recapText_bullet1",
                },
                {
                  text: "PP_S3_O2_recapText_bullet2",
                },
                {
                  text: "PP_S3_O2_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S3_O2_recapPedagogy",
            },
            {
              id: "id-caroline",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene3/MES3Indice3.png",
              recapAlt: "PP_S3_O3_altRecap",
              recapText: "PP_S3_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S3_O3_recapText_bullet1",
                },
                {
                  text: "PP_S3_O3_recapText_bullet2",
                },
                {
                  text: "PP_S3_O3_recapText_bullet3",
                },
                {
                  text: "PP_S3_O3_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S3_O3_recapPedagogy",
            },
            {
              id: "id-zahra",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene3/MES3Indice5.png",
              recapAlt: "PP_S3_O5_altRecap",
              recapText: "PP_S3_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S3_O5_recapText_bullet1",
                },
                {
                  text: "PP_S3_O5_recapText_bullet2",
                  popover: "PP_S3_O5_recapText_bullet2_popover",
                },
                {
                  text: "PP_S3_O5_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S3_O5_recapPedagogy",
            },
            {
              id: "id-sophie",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene3/MES3Indice6.png",
              recapAlt: "PP_S3_O6_altRecap",
              recapText: "PP_S3_O6_recapText",
              recapBullets: [
                {
                  text: "PP_S3_O6_recapText_bullet1",
                },
                {
                  text: "PP_S3_O6_recapText_bullet2",
                },
                {
                  text: "PP_S3_O6_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S3_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-4",
          bg: "scenes/scene4/MES_Background.png",
          overlays: [
            {
              id: "id-baby",
              x: 260,
              y: 389,
              width: 72,
              hotspots: [
                {
                  id: "id-baby-1",
                  x: 257,
                  y: 389,
                  w: 69,
                  h: 100,
                },
              ],
              preview: "scenes/scene4/MES4Indice1.png",
              image: "scenes/scene4/MES4Indice1_cutout.png",
              isMouseOver: false,
              alt: "PP_S4_altObject1",
              clueText: "PP_S4_clueObject1",
              audioUrl: "/audio/scene4/Ici, je suis chez moi_003.mp3",
              audioRecapUrl: "/audio/scene4/Ici, je suis chez moi_004.mp3",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_005.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-kenji-sam",
              x: 173,
              y: 363,
              width: 224,
              hotspots: [
                {
                  id: "id-kenji-sam-1",
                  x: 182,
                  y: 355,
                  w: 86,
                  h: 143,
                },
                {
                  id: "id-kenji-sam-2",
                  x: 337,
                  y: 376,
                  w: 59,
                  h: 134,
                },
              ],
              preview: "scenes/scene4/MES4Indice2.png",
              image: "scenes/scene4/MES4Indice2B_cutout.png",
              isMouseOver: false,
              alt: "PP_S4_altObject2",
              clueText: "PP_S4_clueObject2",
              audioUrl: "/audio/scene4/Ici, je suis chez moi_006.mp3",
              audioRecapUrl: "/audio/scene4/Ici, je suis chez moi_007.mp3",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_008.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-zahra",
              x: 468,
              y: 370,
              width: 206,
              preview: "scenes/scene4/MES4Indice3.png",
              image: "scenes/scene4/MES4Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S4_altObject3",
              clueText: "PP_S4_clueObject3",
              audioUrl: "/audio/scene4/Ici, je suis chez moi_009.mp3",
              audioRecapUrl: "/audio/scene4/Ici, je suis chez moi_010.mp3",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_011.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-mom",
              x: 653,
              y: 126,
              width: 80,
              preview: "scenes/scene4/MES4Indice5.png",
              image: "scenes/scene4/MES4Indice5_cutout.png",
              hotspots: [
                {
                  id: "id-mom-1",
                  x: 648,
                  y: 119,
                  w: 96,
                  h: 200,
                },
              ],
              isMouseOver: true,
              alt: "PP_S4_altObject5",
              clueText: "PP_S4_clueObject5",
              audioUrl: "/audio/scene4/Ici, je suis chez moi_015.mp3",
              audioRecapUrl: "/audio/scene4/Ici, je suis chez moi_016.mp3",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_017.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-dara",
              x: 636,
              y: 335,
              width: 92,
              preview: "scenes/scene4/MES4Indice4.png",
              image: "scenes/scene4/MES4Indice4_cutout.png",
              isMouseOver: true,
              alt: "PP_S4_altObject4",
              clueText: "PP_S4_clueObject4",
              audioUrl: "/audio/scene4/Ici, je suis chez moi_012.mp3",
              audioRecapUrl: "/audio/scene4/Ici, je suis chez moi_013.mp3",
              audioNoteUrl: "/audio/scene4/Ici, je suis chez moi_014.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-telephone",
              x: 38,
              y: 465,
              width: 24,
              preview: "scenes/scene4/MES4Indice6.png",
              image: "scenes/scene4/MES4Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S4_altObject6",
              clueText: "PP_S4_clueObject6",
              audioUrl: "/audio/scene4/Ici, je suis chez moi_018.mp3",
              loaded: true,
              disabled: false,
              relevant: false,
            },
          ],

          recaps: [
            {
              id: "id-baby",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene4/MES4Indice1.png",
              recapAlt: "PP_S4_O1_altRecap",
              recapText: "PP_S4_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S4_O1_recapText_bullet1",
                },
                {
                  text: "PP_S4_O1_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S4_O1_recapPedagogy",
            },
            {
              id: "id-kenji-sam",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene4/MES4Indice2.png",
              recapAlt: "PP_S4_O2_altRecap",
              recapText: "PP_S4_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S4_O2_recapText_bullet1",
                },
                {
                  text: "PP_S4_O2_recapText_bullet2",
                  popover: "PP_S4_O2_recapText_bullet2_popover",
                },
                {
                  text: "PP_S4_O2_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S4_O2_recapPedagogy",
            },
            {
              id: "id-zahra",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene4/MES4Indice3.png",
              recapAlt: "PP_S4_O3_altRecap",
              recapText: "PP_S4_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S4_O3_recapText_bullet1",
                  popover: "PP_S4_O3_recapText_bullet1_popover",
                },
                {
                  text: "PP_S4_O3_recapText_bullet2",
                },
                {
                  text: "PP_S4_O3_recapText_bullet3",
                },
                {
                  text: "PP_S4_O3_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S4_O3_recapPedagogy",
            },
            {
              id: "id-dara",
              clueId: 4,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene4/MES4Indice4.png",
              recapAlt: "PP_S4_O4_altRecap",
              recapText: "PP_S4_O4_recapText",
              recapBullets: [
                {
                  text: "PP_S4_O4_recapText_bullet1",
                },
                {
                  text: "PP_S4_O4_recapText_bullet2",
                },
                {
                  text: "PP_S4_O4_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S4_O4_recapPedagogy",
              popover: "PP_S4_O4_recapPedagogy_popover",
            },
            {
              id: "id-mom",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene4/MES4Indice5.png",
              recapAlt: "PP_S4_O5_altRecap",
              recapText: "PP_S4_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S4_O5_recapText_bullet1",
                },
                {
                  text: "PP_S4_O5_recapText_bullet2",
                  popover: "PP_S4_O5_recapText_bullet2_popover",
                },
              ],
              recapPedagogy: "PP_S4_O5_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-5",
          bg: "scenes/scene5/MES_Background.png",
          overlays: [
            {
              id: "id-kenji-sam",
              x: 489,
              y: 412,
              width: 118,
              preview: "scenes/scene5/MES5Indice1.png",
              image: "scenes/scene5/MES5Indice1_cutout.png",
              isMouseOver: true,
              alt: "PP_S5_altObject1",
              clueText: "PP_S5_clueObject1",
              audioUrl: "/audio/scene5/Nature et découverte_006.mp3",
              audioRecapUrl: "/audio/scene5/Nature et découverte_007.mp3",
              audioNoteUrl: "/audio/scene5/Nature et découverte_008.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-painting",
              x: 377,
              y: 264,
              width: 245,
              preview: "scenes/scene5/MES5Indice2.png",
              image: "scenes/scene5/MES5Indice2_cutout.png",
              isMouseOver: false,
              alt: "PP_S5_altObject2",
              clueText: "PP_S5_clueObject2",
              popover: "PP_S5_clueObject2_popover",
              audioUrl: "/audio/scene5/Nature et découverte_012.mp3",
              audioRecapUrl: "/audio/scene5/Nature et découverte_013.mp3",
              audioNoteUrl: "/audio/scene5/Nature et découverte_014.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-building",
              x: 210,
              y: 303,
              width: 235,
              preview: "scenes/scene5/MES5Indice3.png",
              image: "scenes/scene5/MES5Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S5_altObject3",
              clueText: "PP_S5_clueObject3",
              audioUrl: "/audio/scene5/Nature et découverte_009.mp3",
              audioRecapUrl: "/audio/scene5/Nature et découverte_010.mp3",
              audioNoteUrl: "/audio/scene5/Nature et découverte_011.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-computer",
              x: 650,
              y: 390,
              width: 126,
              preview: "scenes/scene5/MES5Indice4.png",
              image: "scenes/scene5/MES5Indice4_cutout.png",
              isMouseOver: true,
              alt: "PP_S5_altObject4",
              clueText: "PP_S5_clueObject4",
              audioUrl: "/audio/scene5/Nature et découverte_018.mp3",
              selectable: "yes",
              relevant: false,
              loaded: true,
              disabled: false,
            },
            {
              id: "id-door",
              x: 26,
              y: 208,
              width: 85,
              preview: "scenes/scene5/MES5Indice5.png",
              image: "scenes/scene5/MES5Indice5_cutout.png",
              isMouseOver: true,
              alt: "PP_S5_altObject5",
              clueText: "PP_S5_clueObject5",
              audioUrl: "/audio/scene5/Nature et découverte_015.mp3",
              audioRecapUrl: "/audio/scene5/Nature et découverte_016.mp3",
              audioNoteUrl: "/audio/scene5/Nature et découverte_017.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-book",
              x: 125,
              y: 350,
              width: 142,
              preview: "scenes/scene5/MES5Indice6.png",
              image: "scenes/scene5/MES5Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S5_altObject6",
              clueText: "PP_S5_clueObject6",
              audioUrl: "/audio/scene5/Nature et découverte_003.mp3",
              audioRecapUrl: "/audio/scene5/Nature et découverte_004.mp3",
              audioNoteUrl: "/audio/scene5/Nature et découverte_005.mp3",
              loaded: true,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-kenji-sam",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene5/MES5Indice1.png",
              recapAlt: "PP_S5_O1_altRecap",
              recapText: "PP_S5_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S5_O1_recapText_bullet1",
                },
                {
                  text: "PP_S5_O1_recapText_bullet2",
                },
                {
                  text: "PP_S5_O1_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S5_O1_recapPedagogy",
            },
            {
              id: "id-painting",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene5/MES5Indice2.png",
              recapAlt: "PP_S5_O2_altRecap",
              recapText: "PP_S5_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S5_O2_recapText_bullet1",
                },
                {
                  text: "PP_S5_O2_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S5_O2_recapPedagogy",
            },
            {
              id: "id-building",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene5/MES5Indice3.png",
              recapAlt: "PP_S5_O3_altRecap",
              recapText: "PP_S5_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S5_O3_recapText_bullet1",
                },
                {
                  text: "PP_S5_O3_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S5_O3_recapPedagogy",
            },
            {
              id: "id-door",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene5/MES5Indice5.png",
              recapAlt: "PP_S5_O5_altRecap",
              recapText: "PP_S5_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S5_O5_recapText_bullet1",
                },
                {
                  text: "PP_S5_O5_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S5_O5_recapPedagogy",
            },
            {
              id: "id-book",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene5/MES5Indice6.png",
              recapAlt: "PP_S5_O6_altRecap",
              recapText: "PP_S5_O6_recapText",
              recapBullets: [
                {
                  text: "PP_S5_O6_recapText_bullet1",
                },
                {
                  text: "PP_S5_O6_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S5_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-6",
          bg: "scenes/scene6/MES_Background.png",
          overlays: [
            {
              id: "id-blocks",
              x: 396,
              y: 351,
              width: 105,
              preview: "scenes/scene6/MES6Indice1.png",
              image: "scenes/scene6/MES6Indice1_cutout.png",
              isMouseOver: false,
              alt: "PP_S6_altObject1",
              clueText: "PP_S6_clueObject1",
              audioUrl: "/audio/scene6/Un environnement riche_006.mp3",
              audioRecapUrl: "/audio/scene6/Un environnement riche_007.mp3",
              audioNoteUrl: "/audio/scene6/Un environnement riche_008.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-farm",
              x: 302,
              y: 385,
              width: 48,
              preview: "scenes/scene6/MES6Indice2.png",
              image: "scenes/scene6/MES6Indice2_cutout.png",
              isMouseOver: false,
              alt: "PP_S6_altObject2",
              clueText: "PP_S6_clueObject2",
              popover: "PP_S6_clueObject2_popover",
              audioUrl: "/audio/scene6/Un environnement riche_018.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
              relevant: false,
            },
            {
              id: "id-kitchen",
              x: 0,
              y: 167,
              width: 220,
              hotspots: [
                {
                  id: "id-kitchen-1", // brooms
                  x: 0,
                  y: 204,
                  w: 53,
                  h: 71,
                },
                {
                  id: "id-kitchen-2", // pots
                  x: 99,
                  y: 171,
                  w: 64,
                  h: 32,
                },
                {
                  id: "id-kitchen-3", // bowl
                  x: 192,
                  y: 179,
                  w: 24,
                  h: 22,
                },
              ],
              preview: "scenes/scene6/MES6Indice3.png",
              image: "scenes/scene6/MES6Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S6_altObject3",
              clueText: "PP_S6_clueObject3",
              audioUrl: "/audio/scene6/Un environnement riche_015.mp3",
              audioRecapUrl: "/audio/scene6/Un environnement riche_016.mp3",
              audioNoteUrl: "/audio/scene6/Un environnement riche_017.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-books",
              x: 108,
              y: 362,
              width: 144,
              preview: "scenes/scene6/MES6Indice4.png",
              image: "scenes/scene6/MES6Indice4_cutout.png",
              isMouseOver: false,
              alt: "PP_S6_altObject4",
              clueText: "PP_S6_clueObject4",
              popover: "PP_S6_clueObject4_popover",
              audioUrl: "/audio/scene6/Un environnement riche_003.mp3",
              audioRecapUrl: "/audio/scene6/Un environnement riche_004.mp3",
              audioNoteUrl: "/audio/scene6/Un environnement riche_005.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-sand",
              x: 502,
              y: 396,
              width: 290,
              preview: "scenes/scene6/MES6Indice5.png",
              image: "scenes/scene6/MES6Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S6_altObject5",
              clueText: "PP_S6_clueObject5",
              audioUrl: "/audio/scene6/Un environnement riche_009.mp3",
              audioRecapUrl: "/audio/scene6/Un environnement riche_010.mp3",
              audioNoteUrl: "/audio/scene6/Un environnement riche_011.mp3",
              selectable: "yes",
              loaded: false,
              disabled: false,
            },
            {
              id: "id-paint",
              x: 470,
              y: 225,
              width: 244,
              hotspots: [
                {
                  id: "id-paint-1", // table-top
                  x: 481,
                  y: 244,
                  w: 226,
                  h: 90,
                },
              ],
              preview: "scenes/scene6/MES6Indice6.png",
              image: "scenes/scene6/MES6Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S6_altObject6",
              clueText: "PP_S6_clueObject6",
              audioUrl: "/audio/scene6/Un environnement riche_012.mp3",
              audioRecapUrl: "/audio/scene6/Un environnement riche_013.mp3",
              audioNoteUrl: "/audio/scene6/Un environnement riche_014.mp3",
              loaded: false,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-blocks",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene6/MES6Indice1.png",
              recapAlt: "PP_S6_O1_altRecap",
              recapText: "PP_S6_O1_recapText",
              paragraphPopover: "PP_S6_O1_recapText_popover",
              recapBullets: [
                {
                  text: "PP_S6_O1_recapText_bullet1",
                },
                {
                  text: "PP_S6_O1_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S6_O1_recapPedagogy",
            },
            {
              id: "id-kitchen",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene6/MES6Indice3.png",
              recapAlt: "PP_S6_O3_altRecap",
              recapText: "PP_S6_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S6_O3_recapText_bullet1",
                },
                {
                  text: "PP_S6_O3_recapText_bullet2",
                },
                {
                  text: "PP_S6_O3_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S6_O3_recapPedagogy",
              popover: "PP_S6_O3_recapPedagogy_popover",
            },
            {
              id: "id-books",
              clueId: 4,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene6/MES6Indice4.png",
              recapAlt: "PP_S6_O4_altRecap",
              recapText: "PP_S6_O4_recapText",
              recapBullets: [
                {
                  text: "PP_S6_O4_recapText_bullet1",
                },
                {
                  text: "PP_S6_O4_recapText_bullet2",
                },
                {
                  text: "PP_S6_O4_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S6_O4_recapPedagogy",
              popover: "PP_S6_O4_recapPedagogy_popover",
            },
            {
              id: "id-sand",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene6/MES6Indice5.png",
              recapAlt: "PP_S6_O5_altRecap",
              recapText: "PP_S6_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S6_O5_recapText_bullet1",
                },
                {
                  text: "PP_S6_O5_recapText_bullet2",
                },
                {
                  text: "PP_S6_O5_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S6_O5_recapPedagogy",
            },
            {
              id: "id-paint",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene6/MES6Indice6.png",
              recapAlt: "PP_S6_O6_altRecap",
              recapText: "PP_S6_O6_recapText",
              paragraphPopover: "PP_S6_clueObject4_popover",
              recapBullets: [
                {
                  text: "PP_S6_O6_recapText_bullet1",
                },
                {
                  text: "PP_S6_O6_recapText_bullet2",
                },
                {
                  text: "PP_S6_O6_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S6_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-7",
          bg: "scenes/scene7/MES_Background.png",
          overlays: [
            {
              id: "id-horse",
              x: 191,
              y: 420,
              width: 201,
              preview: "scenes/scene7/MES7Indice1.png",
              image: "scenes/scene7/MES7Indice1_cutout.png",
              isMouseOver: false,
              alt: "PP_S7_altObject1",
              clueText: "PP_S7_clueObject1",
              audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_003.mp3",
              audioRecapUrl: "/audio/scene7/Cultiver des saines habitudes de vie_004.mp3",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_005.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-mug",
              x: 245,
              y: 240,
              width: 103,
              preview: "scenes/scene7/MES7Indice2.png",
              image: "scenes/scene7/MES7Indice2_cutout.png",
              isMouseOver: false,
              alt: "PP_S7_altObject2",
              clueText: "PP_S7_clueObject2",
              popover: "PP_S7_clueObject2_popover",
              audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_006.mp3",
              audioRecapUrl: "/audio/scene7/Cultiver des saines habitudes de vie_007.mp3",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_008.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-salad",
              x: 326,
              y: 253,
              width: 120,
              hotspots: [
                {
                  id: "id-salad-2",
                  x: 329,
                  y: 279,
                  w: 41,
                  h: 36,
                },
                {
                  id: "id-salad-4",
                  x: 412,
                  y: 255,
                  w: 32,
                  h: 60,
                },
              ],
              preview: "scenes/scene7/MES7Indice3.png",
              image: "scenes/scene7/MES7Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S7_altObject3",
              clueText: "PP_S7_clueObject3",
              audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_012.mp3",
              audioRecapUrl: "/audio/scene7/Cultiver des saines habitudes de vie_013.mp3",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_014.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-ipad",
              x: 679,
              y: 215,
              width: 70,
              preview: "scenes/scene7/MES7Indice4.png",
              image: "scenes/scene7/MES7Indice4_cutout.png",
              isMouseOver: false,
              alt: "PP_S7_altObject4",
              clueText: "PP_S7_clueObject4",
              popover: "PP_S7_clueObject4_popover",
              audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_018.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
              relevant: false,
            },
            {
              id: "id-tray",
              x: 42,
              y: 288,
              width: 117,
              preview: "scenes/scene7/MES7Indice5.png",
              image: "scenes/scene7/MES7Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S7_altObject5",
              clueText: "PP_S7_clueObject5",
              audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_015.mp3",
              audioRecapUrl: "/audio/scene7/Cultiver des saines habitudes de vie_016.mp3",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_017.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-chair",
              x: 355,
              y: 205,
              width: 50,
              preview: "scenes/scene7/MES7Indice6.png",
              image: "scenes/scene7/MES7Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S7_altObject6",
              clueText: "PP_S7_clueObject6",
              popover: "PP_S7_clueObject6_popover",
              audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_009.mp3",
              audioRecapUrl: "/audio/scene7/Cultiver des saines habitudes de vie_010.mp3",
              audioNoteUrl: "/audio/scene7/Cultiver des saines habitudes de vie_011.mp3",
              loaded: true,
              disabled: false,
            },
          ],
          recaps: [
            {
              id: "id-horse",
              clueId: 1,
              unlocked: false,
              recapImage: "scenes/scene7/MES7Indice1.png",
              recapAlt: "PP_S7_O1_altRecap",
              recapText: "PP_S7_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S7_O1_recapText_bullet1",
                },
                {
                  text: "PP_S7_O1_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S7_O1_recapPedagogy",
            },
            {
              id: "id-mug",
              clueId: 2,
              unlocked: false,
              recapImage: "scenes/scene7/MES7Indice2.png",
              recapAlt: "PP_S7_O2_altRecap",
              recapText: "PP_S7_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S7_O2_recapText_bullet1",
                },
                {
                  text: "PP_S7_O2_recapText_bullet2",
                },
                {
                  text: "PP_S7_O2_recapText_bullet3",
                },
                {
                  text: "PP_S7_O2_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S7_O2_recapPedagogy",
              popover: "PP_S7_O2_recapPedagogy_popover",
            },
            {
              id: "id-salad",
              clueId: 3,
              unlocked: false,
              recapImage: "scenes/scene7/MES7Indice3.png",
              recapAlt: "PP_S7_O3_altRecap",
              recapText: "PP_S7_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S7_O3_recapText_bullet1",
                },
                {
                  text: "PP_S7_O3_recapText_bullet2",
                },
                {
                  text: "PP_S7_O3_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S7_O3_recapPedagogy",
              popover: "PP_S7_O3_recapPedagogy_popover",
            },
            {
              id: "id-tray",
              clueId: 5,
              unlocked: false,
              recapImage: "scenes/scene7/MES7Indice5.png",
              recapAlt: "PP_S7_O5_altRecap",
              recapText: "PP_S7_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S7_O5_recapText_bullet1",
                },
                {
                  text: "PP_S7_O5_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S7_O5_recapPedagogy",
            },
            {
              id: "id-chair",
              clueId: 6,
              unlocked: false,
              recapImage: "scenes/scene7/MES7Indice6.png",
              recapAlt: "PP_S7_O6_altRecap",
              recapText: "PP_S7_O6_recapText",
              paragraphPopover: "PP_S7_clueObject4_popover",
              recapBullets: [
                {
                  text: "PP_S7_O6_recapText_bullet1",
                },
                {
                  text: "PP_S7_O6_recapText_bullet2",
                },
                {
                  text: "PP_S7_O6_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S7_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-8",
          bg: "scenes/scene8/MES_Background.png",
          overlays: [
            {
              id: "id-garden",
              x: 683,
              y: 394,
              width: 109,
              preview: "scenes/scene8/MES8Indice1.png",
              image: "scenes/scene8/MES8Indice1_cutout.png",
              isMouseOver: true,
              alt: "PP_S8_altObject1",
              clueText: "PP_S8_clueObject1",
              audioUrl: "/audio/scene8/On joue dehors_012.mp3",
              audioRecapUrl: "/audio/scene8/On joue dehors_013.mp3",
              audioNoteUrl: "/audio/scene8/On joue dehors_014.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-stroller",
              x: 458,
              y: 299,
              width: 156,
              preview: "scenes/scene8/MES8Indice2.png",
              image: "scenes/scene8/MES8Indice2_cutout.png",
              isMouseOver: true,
              alt: "PP_S8_altObject2",
              clueText: "PP_S8_clueObject2",
              audioUrl: "/audio/scene8/On joue dehors_009.mp3",
              audioRecapUrl: "/audio/scene8/On joue dehors_010.mp3",
              audioNoteUrl: "/audio/scene8/On joue dehors_011.mp3",
              popover: "PP_S8_clueObject2_popover",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-cubes",
              x: 260,
              y: 317,
              width: 193,
              preview: "scenes/scene8/MES8Indice3.png",
              image: "scenes/scene8/MES8Indice3_cutout.png",
              isMouseOver: true,
              alt: "PP_S8_altObject3",
              clueText: "PP_S8_clueObject3",
              audioUrl: "/audio/scene8/On joue dehors_006.mp3",
              audioRecapUrl: "/audio/scene8/On joue dehors_007.mp3",
              audioNoteUrl: "/audio/scene8/On joue dehors_008.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-picnic",
              x: 501,
              y: 221,
              width: 197,
              preview: "scenes/scene8/MES8Indice4.png",
              image: "scenes/scene8/MES8Indice4_cutout.png",
              isMouseOver: true,
              alt: "PP_S8_altObject4",
              clueText: "PP_S8_clueObject4",
              audioUrl: "/audio/scene8/On joue dehors_015.mp3",
              audioRecapUrl: "/audio/scene8/On joue dehors_016.mp3",
              audioNoteUrl: "/audio/scene8/On joue dehors_017.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-horse",
              x: 164,
              y: 288,
              width: 85,
              preview: "scenes/scene8/MES8Indice5.png",
              image: "scenes/scene8/MES8Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S8_altObject5",
              clueText: "PP_S8_clueObject5",
              audioUrl: "/audio/scene8/On joue dehors_018.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
              relevant: false,
            },
            {
              id: "id-counter",
              x: 11,
              y: 275,
              width: 163,
              preview: "scenes/scene8/MES8Indice6.png",
              image: "scenes/scene8/MES8Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S8_altObject6",
              clueText: "PP_S8_clueObject6",
              audioUrl: "/audio/scene8/On joue dehors_003.mp3",
              audioRecapUrl: "/audio/scene8/On joue dehors_004.mp3",
              audioNoteUrl: "/audio/scene8/On joue dehors_005.mp3",
              loaded: true,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-garden",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene8/MES8Indice1.png",
              recapAlt: "PP_S8_O1_altRecap",
              recapText: "PP_S8_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S8_O1_recapText_bullet1",
                },
                {
                  text: "PP_S8_O1_recapText_bullet2",
                },
                {
                  text: "PP_S8_O1_recapText_bullet3",
                },
                {
                  text: "PP_S8_O1_recapText_bullet4",
                },
              ],
              recapPedagogy: "PP_S8_O1_recapPedagogy",
            },
            {
              id: "id-stroller",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene8/MES8Indice2.png",
              recapAlt: "PP_S8_O2_altRecap",
              recapText: "PP_S8_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S8_O2_recapText_bullet1",
                },
                {
                  text: "PP_S8_O2_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S8_O2_recapPedagogy",
              popover: "PP_S8_O2_recapPedagogy_popover",
            },
            {
              id: "id-cubes",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene8/MES8Indice3.png",
              recapAlt: "PP_S8_O3_altRecap",
              recapText: "PP_S8_O3_recapText",
              paragraphPopover: "PP_S8_O3_recapText_popover",
              recapBullets: [
                {
                  text: "PP_S8_O3_recapText_bullet1",
                },
                {
                  text: "PP_S8_O3_recapText_bullet2",
                },
                {
                  text: "PP_S8_O3_recapText_bullet3",
                  popover: "PP_S8_O3_recapText_bullet3_popover",
                },
              ],
              recapPedagogy: "PP_S8_O3_recapPedagogy",
              popover: "PP_S8_O3_recapPedagogy_popover",
            },
            {
              id: "id-picnic",
              clueId: 4,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene8/MES8Indice4.png",
              recapAlt: "PP_S8_O4_altRecap",
              recapText: "PP_S8_O4_recapText",
              recapBullets: [
                {
                  text: "PP_S8_O4_recapText_bullet1",
                },
                {
                  text: "PP_S8_O4_recapText_bullet2",
                },
                {
                  text: "PP_S8_O4_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S8_O4_recapPedagogy",
              popover: "PP_S8_O4_recapPedagogy_popover",
            },
            {
              id: "id-counter",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene8/MES8Indice6.png",
              recapAlt: "PP_S8_O6_altRecap",
              recapText: "PP_S8_O6_recapText",
              recapBullets: [
                {
                  text: "PP_S8_O6_recapText_bullet1",
                },
                {
                  text: "PP_S8_O6_recapText_bullet2",
                },
                {
                  text: "PP_S8_O6_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S8_O6_recapPedagogy",
              popover: "PP_S8_O6_recapPedagogy_popover",
            },
          ],
        },
        {
          id: "id-situation-9",
          bg: "scenes/scene9/MES_Background.png",
          overlays: [
            {
              id: "id-1",
              x: 494,
              y: 345,
              width: 91,
              preview: "scenes/scene9/MES9Indice1.png",
              image: "scenes/scene9/MES9Indice1_cutout.png",
              isMouseOver: false,
              alt: "PP_S9_altObject1",
              clueText: "PP_S9_clueObject1",
              audioUrl: "/audio/scene9/MES1-3-1.mp3",
              audioRecapUrl: "/audio/scene9/MES1-3-1R.mp3",
              audioNoteUrl: "/audio/scene9/MES1-3-1NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-2",
              x: 164,
              y: 254,
              width: 100,
              preview: "scenes/scene9/MES9Indice2.png",
              image: "scenes/scene9/MES9Indice2_cutout.png",
              isMouseOver: true,
              alt: "PP_S9_altObject2",
              clueText: "PP_S9_clueObject2",
              audioUrl: "/audio/scene9/MES1-3-2.mp3",
              audioRecapUrl: "/audio/scene9/MES1-3-2R.mp3",
              audioNoteUrl: "/audio/scene9/MES1-3-2NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-3",
              x: 583,
              y: 243,
              width: 218,
              preview: "scenes/scene9/MES9Indice3.png",
              image: "scenes/scene9/MES9Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S9_altObject3",
              clueText: "PP_S9_clueObject3",
              audioUrl: "/audio/scene9/MES1-3-3.mp3",
              audioRecapUrl: "/audio/scene9/MES1-3-3R.mp3",
              audioNoteUrl: "/audio/scene9/MES1-3-3NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-4",
              x: 5,
              y: 358,
              width: 237,
              preview: "scenes/scene9/MES9Indice4.png",
              image: "scenes/scene9/MES9Indice4_cutout.png",
              isMouseOver: false,
              alt: "PP_S9_altObject4",
              clueText: "PP_S9_clueObject4",
              audioUrl: "/audio/scene9/MES1-3-4.mp3",
              audioRecapUrl: "/audio/scene9/MES1-3-4R.mp3",
              audioNoteUrl: "/audio/scene9/MES1-3-4NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-5",
              x: 155,
              y: 414,
              width: 202,
              preview: "scenes/scene9/MES9Indice5.png",
              image: "scenes/scene9/MES9Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S9_altObject5",
              clueText: "PP_S9_clueObject5",
              audioUrl: "/audio/scene9/MES1-3-5.mp3",
              audioRecapUrl: "/audio/scene9/MES1-3-5R.mp3",
              audioNoteUrl: "/audio/scene9/MES1-3-5NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-6",
              x: 353,
              y: 135,
              width: 138,
              preview: "scenes/scene9/MES9Indice6.png",
              image: "scenes/scene9/MES9Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S9_altObject6",
              clueText: "PP_S9_clueObject6",
              audioUrl: "/audio/scene9/MES1-3-6.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
              relevant: false,
            },
          ],

          recaps: [
            {
              id: "id-1",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene9/MES9Indice1.png",
              recapAlt: "PP_S9_O1_altRecap",
              recapText: "PP_S9_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S9_O1_recapText_bullet1",
                },
                {
                  text: "PP_S9_O1_recapText_bullet2",
                },
                {
                  text: "PP_S9_O1_recapText_bullet3",
                  popover: "PP_S9_O1_recapText_bullet3_popover",
                },
              ],
              recapPedagogy: "PP_S9_O1_recapPedagogy",
            },
            {
              id: "id-2",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene9/MES9Indice2.png",
              recapAlt: "PP_S9_O2_altRecap",
              recapText: "PP_S9_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S9_O2_recapText_bullet1",
                },
                {
                  text: "PP_S9_O2_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S9_O2_recapPedagogy",
            },
            {
              id: "id-3",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene9/MES9Indice3.png",
              recapAlt: "PP_S9_O3_altRecap",
              recapText: "PP_S9_O3_recapText",
              recapBullets: [
                {
                  text: "PP_S9_O3_recapText_bullet1",
                },
                {
                  text: "PP_S9_O3_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S9_O3_recapPedagogy",
            },
            {
              id: "id-4",
              clueId: 4,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene9/MES9Indice4.png",
              recapAlt: "PP_S9_O4_altRecap",
              recapText: "PP_S9_O4_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S9_O4_recapPedagogy",
            },
            {
              id: "id-5",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene9/MES9Indice5.png",
              recapAlt: "PP_S9_O5_altRecap",
              recapText: "PP_S9_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S9_O5_recapText_bullet1",
                },
                {
                  text: "PP_S9_O5_recapText_bullet2",
                  popover: "PP_S9_O5_recapText_bullet2_popover",
                  popover2: "PP_S9_O5_recapText_bullet2_popover2",
                },
                {
                  text: "PP_S9_O5_recapText_bullet3",
                },
              ],
              recapPedagogy: "PP_S9_O5_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-10",
          bg: "scenes/scene10/MES_Background.png",
          overlays: [
            {
              id: "id-1",
              x: 476,
              y: 204,
              width: 131,
              preview: "scenes/scene10/MES10Indice1.png",
              image: "scenes/scene10/MES10Indice1_cutout.png",
              isMouseOver: true,
              alt: "PP_S10_altObject1",
              clueText: "PP_S10_clueObject1",
              audioUrl: "/audio/scene10/MES2-3-1.mp3",
              audioRecapUrl: "/audio/scene10/MES2-3-1R.mp3",
              audioNoteUrl: "/audio/scene10/MES2-3-1NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-2",
              x: 546,
              y: 404,
              width: 272,
              preview: "scenes/scene10/MES10Indice2.png",
              image: "scenes/scene10/MES10Indice2_cutout.png",
              isMouseOver: false,
              alt: "PP_S10_altObject2",
              clueText: "PP_S10_clueObject2",
              audioUrl: "/audio/scene10/MES2-3-2.mp3",
              audioRecapUrl: "/audio/scene10/MES2-3-2R.mp3",
              audioNoteUrl: "/audio/scene10/MES2-3-2NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-3",
              x: 118,
              y: 179,
              width: 236,
              preview: "scenes/scene10/MES10Indice3.png",
              image: "scenes/scene10/MES10Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S10_altObject3",
              clueText: "PP_S10_clueObject3",
              audioUrl: "/audio/scene10/MES2-3-3.mp3",
              audioRecapUrl: "/audio/scene10/MES2-3-3R.mp3",
              audioNoteUrl: "/audio/scene10/MES2-3-3NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-4",
              x: 355,
              y: 217,
              width: 91,
              preview: "scenes/scene10/MES10Indice4.png",
              image: "scenes/scene10/MES10Indice4_cutout.png",
              isMouseOver: false,
              alt: "PP_S10_altObject4",
              clueText: "PP_S10_clueObject4",
              audioUrl: "/audio/scene10/MES2-3-4.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
              relevant: false,
            },
            {
              id: "id-5",
              x: 543,
              y: 302,
              width: 232,
              preview: "scenes/scene10/MES10Indice5.png",
              image: "scenes/scene10/MES10Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S10_altObject5",
              clueText: "PP_S10_clueObject5",
              audioUrl: "/audio/scene10/MES2-3-5.mp3",
              audioRecapUrl: "/audio/scene10/MES2-3-5R.mp3",
              audioNoteUrl: "/audio/scene10/MES2-3-5NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-6",
              x: 102,
              y: 410,
              width: 100,
              preview: "scenes/scene10/MES10Indice6.png",
              image: "scenes/scene10/MES10Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S10_altObject6",
              clueText: "PP_S10_clueObject6",
              audioUrl: "/audio/scene10/MES2-3-6.mp3",
              audioRecapUrl: "/audio/scene10/MES2-3-6R.mp3",
              audioNoteUrl: "/audio/scene10/MES2-3-6NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
          ],
          recaps: [
            {
              id: "id-1",
              clueId: 1,
              unlocked: false,
              recapImage: "scenes/scene10/MES10Indice1.png",
              recapAlt: "PP_S10_O1_altRecap",
              recapText: "PP_S10_O1_recapText",
              paragraphPopover: "PP_S10_O1_recapText_popover",
              recapBullets: [],
              recapPedagogy: "PP_S10_O1_recapPedagogy",
            },
            {
              id: "id-2",
              clueId: 2,
              unlocked: false,
              recapImage: "scenes/scene10/MES10Indice2.png",
              recapAlt: "PP_S10_O2_altRecap",
              recapText: "PP_S10_O2_recapText",
              paragraphPopover: "PP_S10_O2_recapText_popover",
              recapBullets: [],
              recapPedagogy: "PP_S10_O2_recapPedagogy",
            },
            {
              id: "id-3",
              clueId: 3,
              unlocked: false,
              recapImage: "scenes/scene10/MES10Indice3.png",
              recapAlt: "PP_S10_O3_altRecap",
              recapText: "PP_S10_O3_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S10_O3_recapPedagogy",
            },
            {
              id: "id-5",
              clueId: 5,
              unlocked: false,
              recapImage: "scenes/scene10/MES10Indice5.png",
              recapAlt: "PP_S10_O5_altRecap",
              recapText: "PP_S10_O5_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S10_O5_recapPedagogy",
            },
            {
              id: "id-6",
              clueId: 6,
              unlocked: false,
              recapImage: "scenes/scene10/MES10Indice6.png",
              recapAlt: "PP_S10_O6_altRecap",
              recapText: "PP_S10_O6_recapText",
              paragraphPopover: "PP_S10_O6_recapText_popover",
              recapBullets: [],
              recapPedagogy: "PP_S10_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-11",
          bg: "scenes/scene11/MES_Background.png",
          overlays: [
            {
              id: "id-1",
              x: 163,
              y: 244,
              width: 213,
              preview: "scenes/scene11/MES11Indice1.png",
              image: "scenes/scene11/MES11Indice1_cutout.png",
              isMouseOver: false,
              alt: "PP_S11_altObject1",
              clueText: "PP_S11_clueObject1",
              popover: "PP_S11_clueObject1_popover",
              audioUrl: "/audio/scene11/MES3-3-1.mp3",
              audioRecapUrl: "/audio/scene11/MES3-3-1R.mp3",
              audioNoteUrl: "/audio/scene11/MES3-3-1NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-2",
              x: 0,
              y: 213,
              width: 165,
              preview: "scenes/scene11/MES11Indice2.png",
              image: "scenes/scene11/MES11Indice2_cutout.png",
              isMouseOver: false,
              alt: "PP_S11_altObject2",
              clueText: "PP_S11_clueObject2",
              audioUrl: "/audio/scene11/MES3-3-2.mp3",
              audioRecapUrl: "/audio/scene11/MES3-3-2R.mp3",
              audioNoteUrl: "/audio/scene11/MES3-3-2NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-3",
              x: 105,
              y: 184,
              width: 118,
              preview: "scenes/scene11/MES11Indice3.png",
              image: "scenes/scene11/MES11Indice3_cutout.png",
              isMouseOver: true,
              alt: "PP_S11_altObject3",
              clueText: "PP_S11_clueObject3",
              audioUrl: "/audio/scene11/MES3-3-3.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
              relevant: false,
            },
            {
              id: "id-4",
              x: 194,
              y: 308,
              width: 243,
              preview: "scenes/scene11/MES11Indice4.png",
              image: "scenes/scene11/MES11Indice4_cutout.png",
              isMouseOver: true,
              alt: "PP_S11_altObject4",
              clueText: "PP_S11_clueObject4",
              audioUrl: "/audio/scene11/MES3-3-4.mp3",
              audioRecapUrl: "/audio/scene11/MES3-3-4R.mp3",
              audioNoteUrl: "/audio/scene11/MES3-3-4NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-5",
              x: 462,
              y: 362,
              width: 189,
              preview: "scenes/scene11/MES11Indice5.png",
              image: "scenes/scene11/MES11Indice5_cutout.png",
              isMouseOver: true,
              alt: "PP_S11_altObject5",
              clueText: "PP_S11_clueObject5",
              audioUrl: "/audio/scene11/MES3-3-5.mp3",
              audioRecapUrl: "/audio/scene11/MES3-3-5R.mp3",
              audioNoteUrl: "/audio/scene11/MES3-3-5NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-6",
              x: 481,
              y: 253,
              width: 153,
              preview: "scenes/scene11/MES11Indice6.png",
              image: "scenes/scene11/MES11Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S11_altObject6",
              clueText: "PP_S11_clueObject6",
              audioUrl: "/audio/scene11/MES3-3-6.mp3",
              audioRecapUrl: "/audio/scene11/MES3-3-6R.mp3",
              audioNoteUrl: "/audio/scene11/MES3-3-6NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-1",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene11/MES11Indice1.png",
              recapAlt: "PP_S11_O1_altRecap",
              recapText: "PP_S11_O1_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S11_O1_recapPedagogy",
            },
            {
              id: "id-2",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene11/MES11Indice2.png",
              recapAlt: "PP_S11_O2_altRecap",
              recapText: "PP_S11_O2_recapText",
              paragraphPopover: "PP_S11_O2_recapText_popover",
              recapBullets: [],
              recapPedagogy: "PP_S11_O2_recapPedagogy",
              popover: "PP_S11_O2_recapPedagogy_popover",
            },
            {
              id: "id-4",
              clueId: 4,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene11/MES11Indice4.png",
              recapAlt: "PP_S11_O4_altRecap",
              recapText: "PP_S11_O4_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S11_O4_recapPedagogy",
            },
            {
              id: "id-5",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene11/MES11Indice5.png",
              recapAlt: "PP_S11_O5_altRecap",
              recapText: "PP_S11_O5_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S11_O5_recapPedagogy",
            },
            {
              id: "id-6",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene11/MES11Indice6.png",
              recapAlt: "PP_S11_O6_altRecap",
              recapText: "PP_S11_O6_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S11_O6_recapPedagogy",
            },
          ],
        },
        {
          id: "id-situation-12",
          bg: "scenes/scene12/MES_Background.png",
          overlays: [
            {
              id: "id-1",
              x: 655,
              y: 161,
              width: 136,
              preview: "scenes/scene12/MES12Indice1.png",
              image: "scenes/scene12/MES12Indice1_cutout.png",
              isMouseOver: false,
              alt: "PP_S12_altObject1",
              clueText: "PP_S12_clueObject1",
              audioUrl: "/audio/scene12/MES4-3-1.mp3",
              audioRecapUrl: "/audio/scene12/MES4-3-1R.mp3",
              audioNoteUrl: "/audio/scene12/MES4-3-1NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-2",
              x: 105,
              y: 244,
              width: 92,
              preview: "scenes/scene12/MES12Indice2.png",
              image: "scenes/scene12/MES12Indice2_cutout.png",
              isMouseOver: true,
              alt: "PP_S12_altObject2",
              clueText: "PP_S12_clueObject2",
              audioUrl: "/audio/scene12/MES4-3-2.mp3",
              audioRecapUrl: "/audio/scene12/MES4-3-2R.mp3",
              audioNoteUrl: "/audio/scene12/MES4-3-2NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-3",
              x: 224,
              y: 281,
              width: 72,
              preview: "scenes/scene12/MES12Indice3.png",
              image: "scenes/scene12/MES12Indice3_cutout.png",
              isMouseOver: false,
              alt: "PP_S12_altObject3",
              clueText: "PP_S12_clueObject3",
              audioUrl: "/audio/scene12/MES4-3-3.mp3",
              audioRecapUrl: "/audio/scene12/MES4-3-3R.mp3",
              audioNoteUrl: "/audio/scene12/MES4-3-3NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-4",
              x: 44,
              y: 220,
              width: 55,
              preview: "scenes/scene12/MES12Indice4.png",
              image: "scenes/scene12/MES12Indice4_cutout.png",
              isMouseOver: true,
              alt: "PP_S12_altObject4",
              clueText: "PP_S12_clueObject4",
              audioUrl: "/audio/scene12/MES4-3-4.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
              relevant: false,
            },
            {
              id: "id-5",
              x: 427,
              y: 277,
              width: 56,
              preview: "scenes/scene12/MES12Indice5.png",
              image: "scenes/scene12/MES12Indice5_cutout.png",
              isMouseOver: false,
              alt: "PP_S12_altObject5",
              clueText: "PP_S12_clueObject5",
              audioUrl: "/audio/scene12/MES4-3-5.mp3",
              audioRecapUrl: "/audio/scene12/MES4-3-5R.mp3",
              audioNoteUrl: "/audio/scene12/MES4-3-5NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
            {
              id: "id-6",
              x: 351,
              y: 408,
              width: 126,
              preview: "scenes/scene12/MES12Indice6.png",
              image: "scenes/scene12/MES12Indice6_cutout.png",
              isMouseOver: false,
              alt: "PP_S12_altObject6",
              clueText: "PP_S12_clueObject6",
              audioUrl: "/audio/scene12/MES4-3-6.mp3",
              audioRecapUrl: "/audio/scene12/MES4-3-6R.mp3",
              audioNoteUrl: "/audio/scene12/MES4-3-6NP.mp3",
              selectable: "yes",
              loaded: true,
              disabled: false,
            },
          ],

          recaps: [
            {
              id: "id-1",
              clueId: 1,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene12/MES12Indice1.png",
              recapAlt: "PP_S12_O1_altRecap",
              recapText: "PP_S12_O1_recapText",
              recapBullets: [
                {
                  text: "PP_S12_O1_recapText_bullet1",
                },
                {
                  text: "PP_S12_O1_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S12_O1_recapPedagogy",
            },
            {
              id: "id-2",
              clueId: 2,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene12/MES12Indice2.png",
              recapAlt: "PP_S12_O2_altRecap",
              recapText: "PP_S12_O2_recapText",
              recapBullets: [
                {
                  text: "PP_S12_O2_recapText_bullet1",
                },
                {
                  text: "PP_S12_O2_recapText_bullet2",
                },
              ],
              recap2Text: "PP_S12_O2_recap2Text",
              recapPedagogy: "PP_S12_O2_recapPedagogy",
            },
            {
              id: "id-3",
              clueId: 3,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene12/MES12Indice3.png",
              recapAlt: "PP_S12_O3_altRecap",
              recapText: "PP_S12_O3_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S12_O3_recapPedagogy",
            },
            {
              id: "id-5",
              clueId: 5,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene12/MES12Indice5.png",
              recapAlt: "PP_S12_O5_altRecap",
              recapText: "PP_S12_O5_recapText",
              recapBullets: [
                {
                  text: "PP_S12_O5_recapText_bullet1",
                },
                {
                  text: "PP_S12_O5_recapText_bullet2",
                },
              ],
              recapPedagogy: "PP_S12_O5_recapPedagogy",
            },
            {
              id: "id-6",
              clueId: 6,

              // Recap screens ---------------------
              unlocked: false,
              recapImage: "scenes/scene12/MES12Indice6.png",
              recapAlt: "PP_S12_O6_altRecap",
              recapText: "PP_S12_O6_recapText",
              recapBullets: [],
              recapPedagogy: "PP_S12_O6_recapPedagogy",
            },
          ],
        },
      ],
      showingPopup: -1,
      showingWrongAnswerPopup: -1,
      showingRecap: false,
      searchMode: false,
      //storyLineLink: "Storyline/story.html",
      //storyLineText: "Link to story line",

      // Audio
      sfxGoodAnswer: "/audio/sfx/SFX_CollectStar.mp3",
      clueAudioPertinent: "/audio/partager/partager_indice_pertinent.mp3",
      clueAudioNotPertinent: "/audio/partager/partager_indice_non_pertinent.mp3",
      keepClueAudio: "/audio/partager/partager_keep_clue.mp3",
      musicAudio: "/audio/partager/music.mp3",
    };
  },
  mounted() {
    this.unlockAllObjectsFromSaveGame();

    if (this.newVersion()) {
      this.shiftCirclesX(-40);
    }

    this.playAudioByRefName("musicAudioRef");

    this.disableAllOverlaysOnGameCompleted();

    if (this.$route.query.indice != undefined) {
      this.showSpecificRecap();
    }
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);

    this.saveGameState();
  },
  methods: {
    disableAllOverlaysOnGameCompleted() {
      if (this.isGameCompleted()) {
        this.disableAllOverlays(true);
      }
    },
    isGameCompleted() {
      let availableSlots = this.overlaysCircles.length - 1;
      return this.currentCircle >= availableSlots;
    },

    showSpecificRecap() {
      let indiceId = parseInt(this.$route.query.indice);
      let maxIndice = this.getRecaps().length;
      let indiceTab = this.getTabIndex(indiceId);

      if (indiceTab >= 0 && indiceTab <= maxIndice) {
        this.searchMode = true;
        this.showRecapPage(false, indiceTab);
      }
    },

    getTabIndex(indiceId) {
      let indiceTab = indiceId;
      let Overlays = this.getOverlays();

      for (let i = 0; i < indiceId; i++) {
        console.log(Overlays[i].relevant);
        if (Overlays[i].relevant == false) {
          indiceTab = indiceTab - 1;
          console.log(indiceTab);
        }
      }
      return indiceTab;
    },

    onClueAudioEnded() {
      if (Number(this.getCurrentSituation()) < 4) {
        this.playAudioByRefName("keepClueRef");
      }
    },
    shiftCirclesX(offset) {
      for (var i = 0; i < this.overlaysCircles.length; i++) {
        this.overlaysCircles[i].x += offset;
      }
    },
    getPlayFrame() {
      if (!this.newVersion()) {
        return "play-frame";
      }
      return "play-frame-new";
    },
    isClueRelevant(overlay) {
      if (overlay.relevant == false) {
        return false;
      }
      return true;
    },
    getAddToNotesLabel() {
      return "G_continueLabel";
    },
    getSituationName() {
      return this.LG(`QI_S${this.getCurrentSituation() + 1}_Name`);
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    getCurrentClue() {
      return this.currentClue;
    },
    calculateClueIndex() {
      var numOverlays = this.situations[this.getCurrentSituation()].overlays.length; // MUST BE 6!
      if (numOverlays != 6) {
        alert("WARNING!  You must have exactly 6 overlays per situation, invalid situation: " + this.getCurrentSituation() + " has " + numOverlays + " recaps.");
      }
      var clueIndex = numOverlays * this.getCurrentSituation() + this.currentClue;
      //console.log("calculateClueIndex clue index: " + this.currentClue + " = " + clueIndex);
      return clueIndex;
    },
    unlockAllObjectsFromSaveGame() {
      //console.log("unlockAllObjectsFromSaveGame");
      this.currentCircle = 0; // calculate
      // Loop through all the recaps, and addImageToCircle if clues unlocked in save file
      var numOverlays = this.situations[this.getCurrentSituation()].overlays.length; // MUST BE 6!
      for (var i = 0; i < numOverlays; i++) {
        this.currentClue = i;
        var clueIndex = this.calculateClueIndex();
        if (this.$store.state.gamestate.clues[clueIndex]) {
          this.addImageToCircle();
          this.unlockTabForCurrentObject();
        }
      }
    },
    disableAllOverlays(disable) {
      //console.log("DisableAllOverlays: " + disable);
      var numOverlays = this.situations[this.getCurrentSituation()].overlays.length;
      for (var i = 0; i < numOverlays; i++) {
        var ov = this.situations[this.getCurrentSituation()].overlays[i];
        if (ov.disabled != null) {
          ov.disabled = disable;
        }
      }
    },
    getCurrentObject() {
      return this.situations[this.getCurrentSituation()].overlays[this.getCurrentClue()];
    },
    getOverlays() {
      return this.situations[this.getCurrentSituation()].overlays;
    },
    getOverlayBG() {
      return this.situations[this.getCurrentSituation()].bg;
    },
    getRecaps() {
      return this.situations[this.getCurrentSituation()].recaps;
    },
    getPopupImage(overlay) {
      return require("@/assets/" + overlay.preview);
    },
    getPopupAlt(overlay) {
      return overlay.alt;
    },
    getClueText(overlay) {
      return overlay.clueText;
    },
    hasCluePopover(overlay) {
      if (overlay.popover != null) {
        return true;
      }
      return false;
    },
    getCluePopover(overlay) {
      if (overlay.popover == null) {
        return "";
      }
      return overlay.popover;
    },
    hasClueAudio(overlay) {
      if (this.getClueAudio(overlay) == null) {
        return false;
      }
      return true;
    },
    getClueAudio(overlay) {
      return overlay.audioUrl;
    },
    getClueAudioRef(index) {
      return "clueAudioRef" + index;
    },
    hasRecapAudio(overlay) {
      if (this.getRecapAudio(overlay) == null) {
        return false;
      }
      return true;
    },
    getRecapAudio(overlay) {
      return overlay.audioRecapUrl;
    },
    getRecapAudioRef(index) {
      return "recapAudioRef" + index;
    },
    hasNoteAudio(overlay) {
      if (this.getNoteAudio(overlay) == null) {
        return false;
      }
      return true;
    },
    getNoteAudio(overlay) {
      return overlay.audioNoteUrl;
    },
    getNoteAudioRef(index) {
      return "noteAudioRef" + index;
    },
    IsSituation(index) {
      if (index == this.getCurrentSituation()) {
        return true;
      }
      return false;
    },
    unlockTabForCurrentObject() {
      if (this.isClueRelevant(this.getCurrentObject()) == true) {
        var selectedId = this.getCurrentObject().id;

        for (var i = 0; i < this.getRecaps().length; i++) {
          var recap = this.getRecaps()[i];
          if (recap.id == selectedId) {
            recap.unlocked = true;
            console.log("Unlocking for current object: " + i);
            break;
          }
        }
      }
    },
    onNextButtonClicked() {
      this.playNoteAudio();
    },
    onPrevButtonClicked() {
      this.playRecapAudio();
    },
    playNoteAudio() {
      this.pauseAllAudio();
      var index = this.getCurrentClue();
      var noteRefName = this.$refs[this.getNoteAudioRef(index)];
      this.playAudioByRefName(noteRefName);
    },
    playRecapAudio() {
      this.pauseAllAudio();

      var index = this.getCurrentClue();
      var name = this.getRecapAudioRef(index);
      this.playAudioByRefName(name);
    },
    getSelectedUnlockedClue() {
      var selectedId = this.getCurrentObject().id;

      for (var i = 0; i < this.getRecaps().length; i++) {
        var recap = this.getRecaps()[i];
        if (recap.id == selectedId) {
          return i;
        }
      }
      return -1;
    },
    onOkButtonClicked(overlay) {
      this.playRecapAudio();

      // If a relevant clue, we'll show the recap screen etc.., otherwise just close popup
      if (this.isClueRelevant(this.getCurrentObject()) == true) {
        var startTab = this.getSelectedUnlockedClue();
        if (startTab != -1) {
          this.playAudioByRefName("sfxGoodAnswerRef");
          this.searchMode = false;
          this.showRecapPage(false, startTab);
        } else {
          console.log("ERROR!  invalid start tab found!");
        }
      } else {
        // Non-relevant
        this.showingRecap = false;

        // In the new version, if you get it "wrong" and try to collect an irrelevant object, you get the popup explaining that it's not relevant
        if (this.newVersion()) {
          this.showingWrongAnswerPopup = this.showingPopup;
          this.$bvModal.show(overlay.id + "_wrong");
          this.pauseAllAudio();
          this.playAudioByRefName("clueAudioNotPertinentRef");
        } else {
          // Now make this irrelevant object no longer selectable so you can only get it once
          this.getCurrentObject().selectable = "no";
        }

        this.disableAllOverlays(false); // TBD is this correct?
      }

      this.showingPopup = -1;
    },
    onDismissWrongAnswerMessage() {
      // No just a normal close action
      this.onCloseButtonClicked();
    },
    onCloseButtonClicked() {
      this.pauseAllAudio();
      this.showingPopup = -1;
      this.showingWrongAnswerPopup = -1;
      this.disableAllOverlays(false);
    },
    onNoButtonClicked(overlay) {
      // If you correctly answer "no", (because clue is not relevant) make it no longer selectable
      if (!this.isClueRelevant(overlay)) {
        // Now make this object no longer selectable so you can only get it once
        this.getCurrentObject().selectable = "no";

        this.onCloseButtonClicked();
        this.playAudioByRefName("sfxGoodAnswerRef");
      } else {
        // If you incorrectly answer "no" and this clue is relevant, show the wrong answer popup & play audio
        this.showingWrongAnswerPopup = this.showingPopup;
        this.$bvModal.show(overlay.id + "_wrong");
        this.pauseAllAudio();
        this.playAudioByRefName("clueAudioPertinentRef");
      }
    },
    addImageToCircle() {
      var thumb = this.getCurrentObject().preview;
      if (thumb != null) {
        // add the thumbnail to the next available overlay circle (circles along bottom of scene)
        this.overlaysCircles[this.currentCircle].image = thumb;

        // Now make the object no longer selectable so you can only get it once
        this.getCurrentObject().selectable = "no";

        // one slot is used up by the search button
        // var availableSlots = this.overlaysCircles.length - 1;

        this.currentCircle++;
        // if (this.currentCircle >= availableSlots) {
        //   this.currentCircle = 0;
        //   this.showRecapPage(true, 0);
        // }
      }
    },
    getObjectIndexFromTabIndex(tabIndex) {
      //console.log("Looking for recap id for " + tabIndex);
      var recapId = this.getRecaps()[tabIndex].id;
      if (tabIndex != -1) {
        for (var i = 0; i < this.getOverlays().length; i++) {
          if (this.getOverlays()[i].id == recapId) {
            return i;
          }
        }
      }
      alert("Failed to find object index for tab: " + tabIndex + " which has an id of: " + recapId);
      return -1;
    },
    onTabClicked(index) {
      this.pauseAllAudio();
      var name = this.getRecapAudioRef(index);
      this.playAudioByRefName(name);
    },
    onRecapComplete(saveProgress) {
      this.pauseAllAudio();

      this.showingRecap = false;

      // You never "earn" anything while in search mode, only browsing
      if (this.searchMode == false && saveProgress) {
        // Mark clue index as found in store
        var clueIndex = this.calculateClueIndex();

        this.$store.commit("setClueFound", clueIndex);

        if (!this.$refs.refClues.showingResumePage) {
          this.addImageToCircle();
        } else {
          this.onPlayComplete();
        }

        this.saveGameState();
      }

      this.disableAllOverlays(false);

      this.searchMode = false;
    },
    onPlayComplete() {
      this.$router.push("/intervention");
    },
    onSearchClicked() {
      this.searchMode = true;

      this.disableAllOverlays(true);

      var startTab = this.getSelectedUnlockedClue();
      if (startTab == -1) {
        startTab = this.findFirstUnlockedClue();
      }
      if (this.startTab != -1) {
        this.pauseAllAudio();
        this.playRecapAudio();

        this.showRecapPage(false, startTab);
      }
    },
    findFirstUnlockedClue() {
      var numRecaps = this.getRecaps().length;
      for (var i = 0; i < numRecaps; i++) {
        if (this.getRecaps()[i].unlocked == true) {
          return i;
        }
      }
      return -1;
    },
    onObjectClicked(index) {
      this.pauseAllAudio();
      this.playAudioByRefName(this.getClueAudioRef(index));
      this.currentClue = Number(index);
      this.showingPopup = index;
      this.disableAllOverlays(true);
      this.$store.commit("setCurrentClue", this.currentClue);
      this.popToTopOfPage();
    },
    showRecapPage(resumeSection, startTab) {
      this.$refs.refClues.showingResumePage = resumeSection;
      this.$refs.refClues.showingPedagogyPage = false;
      this.$refs.refClues.currentTab = startTab;
      this.$refs.refClues.searchMode = this.searchMode;

      if (this.searchMode) {
        this.$bvModal.show("clueRecapsModalTab");
      } else {
        this.$bvModal.show("clueRecapsModalSingle");
      }

      //console.log("UNLOCKING tab " + startTab + " from show");
      this.getRecaps()[startTab].unlocked = true;
      this.showingRecap = true;

      if (resumeSection == true) {
        this.disableAllOverlays(false);
        //this.$router.push(`/${this.areaName}/${this.situationName}/resume`);
      }
    },
    onFinishedButtonClicked() {
      this.$router.push(`/${this.areaName}/${this.situationName}/resume`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.next-btn-wrapper::v-deep {
  font-family: "Poppins";

  border-radius: 50px;
  border: 10px solid #ffffff;
  background-color: #f3f3f3 !important;

  width: 95%;
  max-width: 800px;

  position: absolute;
  z-index: 1;
  top: 400px;
  left: 50%;
  transform: translateX(-50%);

  padding: 30px;
}
.next-btn::v-deep {
  margin-top: 20px;
  float: right;
}
.popup-screen-overlay::v-deep,
.recap-screen-overlay::v-deep {
  z-index: 2;
}
</style>
<style>
.back-button {
  color: white;
}

.root-image {
  position: relative;
}

.center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.play-frame {
  background: white;
  background-color: white;
  color: black;
  max-width: 950px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 25px;
}

.play-frame-new {
  background-color: white !important;
  max-width: 1100px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;
  border-radius: 60px;
}

.popup-area {
  padding-left: 50px;
}

@media only screen and (max-width: 1300px) {
  .popup-area {
    padding-left: 0px;
  }
}
</style>
